import fetch from '../utils/fetch'
// 获取学生端接口
// 获取学生资料信息  https://student.wqisland.com/api
// eslint-disable-next-line import/prefer-default-export
export const studentList = () =>
  fetch
    .post('/student/info')
    .then(res => res)
    .catch()

// 获取整个周的作业情况
export const allQuestion = data =>
  fetch
    .post('/student/homework/week', data)
    .then(res => res)
    .catch()
// 获取题目信息 先写死
export const question = data =>
  fetch
    .post('/student/tools/question/id', data)
    .then(res => res)
    .catch()

// 其他接口 提交作业信息
export const answer = data =>
  fetch
    .post('/student/homework/question/reply', data)
    .then(res => res)
    .catch()
// 根据作业周、作业次、题型获取对应题目详情列表
export const getQuestionList = data =>
  fetch
    .post('/student/question/detail/by/week/times/type', data)
    .then(res => res)
    .catch()
// 保存对弈的结果
export const saveMechineResult = data =>
  fetch
    .post('/student/homework/battle/reply', data)
    .then(res => res)
    .catch()
// 获取对弈记录查询
export const getMechineResult = data =>
  fetch
    .post('/student/battle/history/summary', data)
    .then(res => res)
    .catch()
// 获取单个对弈记录详细情况（包含走子）
export const getMechineResultDetails = data =>
  fetch
    .post('/student/homework/battle/detail', data)
    .then(res => res)
    .catch()

export const getQuestionAudio = params =>
  fetch
    .get('/common/api/getAudioUrl', { params })
    .then(res => res)
    .catch()

export const getQuestionAudioAll = params =>
  fetch
    .get('/common/api/batchGetAudioUrl', { params })
    .then(res => res)
    .catch()
